<div class="flex flex-col gap-0.5">
  <h2 class="text-xl font-semibold">Zeitraum ändern</h2>
  <span class="text-light text-sm">Bitte Zeitraum anpassen/ändern</span>
</div>

<form [formGroup]="form" class="flex flex-col gap-4 mt-3">
  <div class="flex flex-row w-full gap-4">
    <div class="flex flex-col w-full gap-0.5">
      <label for="vondatum" class="soft-label top">Von-Datum</label>
      <soft-date-input
        id="vondatum"
        placeholder="Von-Datum"
        formControlName="vondatum"
      ></soft-date-input>
    </div>

    <div class="flex flex-col w-full gap-0.5">
      <label for="bisdatum" class="soft-label top">Von-Datum</label>
      <soft-date-input
        id="bisdatum"
        placeholder="Bis-Datum"
        formControlName="bisdatum"
      ></soft-date-input>
    </div>
  </div>
</form>

<button
  class="soft-button accent h-16 w-full text-center mt-4"
  (click)="resolve(form.getRawValue())"
>
  Zeitraum ändern
</button>
